
// tslint:disable
export enum WIDGETS_ID {
  // DURATION DAYS
  DURATION_DAYS = 'duration_days',
  AVG_DURATION_HOURS = 'avg_duration_hours',
  AVG_DURATION_HOURS_LIST_DAY = 'avg_duration_hours_list_morning',
  AVG_DURATION_HOURS_LIST_AFTERNOON = 'avg_duration_hours_list_afternoon',
  WEEKLY_EVOLUTION_SERVICE_LEVEL = 'weekly_evolution_service_level',
  WEEKLY_EVOLUTION_TRAFFIC_INTENSITY = 'weekly_evolution_traffic_intensity',
  WEEKLY_EVOLUTION_JAM_DURATION = 'weekly_evolution_jam_duration',
};

export const WIDGET_SQL = {};

WIDGET_SQL[WIDGETS_ID.DURATION_DAYS] = `
  SELECT
  DATE(georss_date) AS date,
  MAX(duration_seconds) as duration_seconds
  FROM
  amb_waze_data_jams_agg_hour
  WHERE
  georss_date >= FILTER_FROM
  AND georss_date < FILTER_TO
  AND ntram IN (
    SELECT
      ntram
    FROM
      amb_streetsBYPASS
    WHERE FILTER_BBOX_WIDGETS
  )
  AND duration_seconds < 86400
  GROUP BY
  DATE(georss_date)
  ORDER BY
  MAX(duration_seconds) DESC
  LIMIT 5`;

WIDGET_SQL[WIDGETS_ID.AVG_DURATION_HOURS] = `
  WITH jams_in_period_durations AS (
    SELECT
      CASE
        WHEN FILTER_TO <= end_ts THEN
          EXTRACT(EPOCH from FILTER_TO - start_ts)
        ELSE
          EXTRACT(EPOCH from end_ts - start_ts)
      END AS duration_seconds
    FROM
      amb_waze_data_jams_agg_times
    WHERE
      start_ts <= FILTER_TO
      AND end_ts >= FILTER_FROM
      AND ntram IN (
        SELECT
          ntram
        FROM
          amb_streetsBYPASS
        WHERE FILTER_BBOX_WIDGETS
      )
  )
  SELECT
    AVG(duration_seconds) FILTER (WHERE duration_seconds > 0) AS duration_seconds
  FROM
    jams_in_period_durations`;

WIDGET_SQL[WIDGETS_ID.AVG_DURATION_HOURS_LIST_DAY] = `
  SELECT
  start_ts AS range_morning_from,
  end_ts AS range_morning_to
  FROM
  amb_waze_data_jams_agg_times
  WHERE
  start_ts <= FILTER_TO
  AND end_ts >= FILTER_FROM
  AND ntram IN (
    SELECT
      ntram
    FROM
      amb_streetsBYPASS
    WHERE FILTER_BBOX_WIDGETS
  )
  AND EXTRACT(HOUR FROM start_ts) BETWEEN 4 AND 11
  AND EXTRACT(HOUR FROM end_ts) BETWEEN 4 AND 11
  ORDER BY
  (end_ts - start_ts) DESC
  LIMIT 1`;

WIDGET_SQL[WIDGETS_ID.AVG_DURATION_HOURS_LIST_AFTERNOON] = `
  SELECT
  start_ts AS range_afternoon_from,
  end_ts AS range_afternoon_to
  FROM
  amb_waze_data_jams_agg_times
  WHERE
  start_ts <= FILTER_TO
  AND end_ts >= FILTER_FROM
  AND ntram IN (
    SELECT
      ntram
    FROM
      amb_streetsBYPASS
    WHERE FILTER_BBOX_WIDGETS
  )
  AND EXTRACT(HOUR FROM start_ts) BETWEEN 11 AND 20
  AND EXTRACT(HOUR FROM end_ts) BETWEEN 11 AND 20
  ORDER BY
  (end_ts - start_ts) DESC
  LIMIT 1`;

WIDGET_SQL[WIDGETS_ID.WEEKLY_EVOLUTION_SERVICE_LEVEL] = `WITH base_levels AS( SELECT d.dow, h.hour, 0 AS level FROM GENERATE_SERIES(1, 7) AS d (dow) JOIN GENERATE_SERIES(0, 23) AS h (hour) ON TRUE), adapted_lvls_by_hour AS ( SELECT georss_date, ROUND(level::double precision * LEAST ((affected_ntrams::double precision / total_ntrams::double precision), 1)) AS level FROM ( SELECT a.georss_date, COUNT(*) FILTER ( WHERE a.ntram IN ( SELECT ntram FROM amb_streetsBYPASS WHERE FILTER_BBOX_WIDGETS ) ) AS affected_ntrams, AVG(t.total)::integer AS total_ntrams, AVG(a.avg_level)::integer AS level FROM amb_waze_data_jams_agg_hour a JOIN ( SELECT GREATEST(ROUND(COUNT(*) * 0.1), 1) AS total FROM amb_streetsBYPASS WHERE FILTER_BBOX_WIDGETS ) t ON TRUE WHERE georss_date >= FILTER_FROM AND georss_date < FILTER_TO GROUP BY a.georss_date ) x ), filtered_data AS ( SELECT EXTRACT(ISODOW FROM georss_date) AS dow, EXTRACT(HOUR FROM georss_date) AS hour, CEIL(AVG(level))::integer AS level FROM adapted_lvls_by_hour GROUP BY EXTRACT(ISODOW FROM georss_date), EXTRACT(HOUR FROM georss_date)) SELECT b.dow AS day, b.hour, COALESCE(fd.level, b.level) AS level FROM base_levels b LEFT JOIN filtered_data fd ON fd.dow = b.dow AND fd.hour = b.hour;`;

WIDGET_SQL[WIDGETS_ID.WEEKLY_EVOLUTION_JAM_DURATION] = `WITH base_levels AS( SELECT d.dow, h.hour, 0 AS level FROM GENERATE_SERIES(1, 7) AS d (dow) JOIN GENERATE_SERIES(0, 23) AS h (hour) ON TRUE), ntrams_in_bbox AS ( SELECT ntram FROM amb_streetsBYPASS WHERE FILTER_BBOX_WIDGETS ), ntrams_in_bbox_count AS ( SELECT GREATEST(ROUND(COUNT(*) * 0.1), 1) AS total FROM ntrams_in_bbox ), jam_durations_in_period AS ( SELECT a.georss_date, AVG( CASE WHEN a.duration_seconds <= 0 THEN 180 ELSE a.duration_seconds END ) AS duration_seconds, COUNT(*) FILTER (WHERE a.ntram IN (SELECT ntram FROM ntrams_in_bbox)) AS affected_ntrams, AVG(nbbox.total) AS total_ntrams FROM amb_waze_data_jams_agg_hour a JOIN ntrams_in_bbox_count nbbox ON TRUE WHERE georss_date >= FILTER_FROM AND georss_date < FILTER_TO GROUP BY georss_date ), jams_durations_levels AS ( SELECT georss_date, CASE WHEN duration_seconds < 600 THEN 1 WHEN duration_seconds >= 600 AND duration_seconds < 1200 THEN 2 WHEN duration_seconds >= 1200 AND duration_seconds < 1800 THEN 3 WHEN duration_seconds >= 1800 AND duration_seconds < 3600 THEN 4 ELSE 5 END AS level, affected_ntrams, total_ntrams FROM jam_durations_in_period ), jams_durations_levels_adapted AS ( SELECT georss_date, ROUND(level::double precision * LEAST ((affected_ntrams::double precision / total_ntrams::double precision), 1)) AS level FROM jams_durations_levels ), filtered_data AS ( SELECT EXTRACT(ISODOW FROM georss_date) AS dow, EXTRACT(HOUR FROM georss_date) AS hour, CEIL(AVG(level))::integer AS level FROM jams_durations_levels_adapted GROUP BY EXTRACT(ISODOW FROM georss_date), EXTRACT(HOUR FROM georss_date) ) SELECT b.dow AS day, b.hour, COALESCE(fd.level, b.level) AS level FROM base_levels b LEFT JOIN filtered_data fd ON fd.dow = b.dow AND fd.hour = b.hour;`;

WIDGET_SQL[WIDGETS_ID.WEEKLY_EVOLUTION_TRAFFIC_INTENSITY] = `WITH base_levels AS( SELECT d.dow, h.hour, 0 AS level FROM GENERATE_SERIES(1, 7) AS d (dow) JOIN GENERATE_SERIES(0, 23) AS h (hour) ON TRUE), ntrams_in_bbox AS ( SELECT ntram FROM amb_streetsBYPASS WHERE FILTER_BBOX_WIDGETS ), ntrams_in_bbox_count AS ( SELECT GREATEST(ROUND(COUNT(*) * 0.1), 1) AS total FROM ntrams_in_bbox ), road_sections_with_types AS ( SELECT j.georss_date, j.ntram, j.avg_speed, j.avg_level AS level, j.road_type, s.carrils FROM amb_waze_data_jams_agg_hour j JOIN amb_streetsBYPASS s ON S.FILTER_BBOX_WIDGETS AND j.ntram = s.ntram WHERE j.georss_date >= FILTER_FROM AND j.georss_date < FILTER_TO ), road_sections_with_intensities AS ( SELECT rt.georss_date, AVG( CASE WHEN rt.road_type IN (3, 6, 7, 17) THEN CASE WHEN level = 1 THEN rt.avg_speed * 50 * (COALESCE(rt.carrils, 2) / 2) WHEN level = 2 THEN rt.avg_speed * 58 * (COALESCE(rt.carrils, 2) / 2) WHEN level = 3 THEN rt.avg_speed * 72 * (COALESCE(rt.carrils, 2) / 2) WHEN level = 4 THEN rt.avg_speed * 80 * (COALESCE(rt.carrils, 2) / 2) WHEN level = 5 THEN rt.avg_speed * 94 * (COALESCE(rt.carrils, 2) / 2) ELSE 0 END ELSE CASE WHEN level = 1 THEN rt.avg_speed * 25 * COALESCE(rt.carrils, 1) WHEN level = 2 THEN rt.avg_speed * 27 * COALESCE(rt.carrils, 1) WHEN level = 3 THEN rt.avg_speed * 28 * COALESCE(rt.carrils, 1) WHEN level = 4 THEN rt.avg_speed * 29 * COALESCE(rt.carrils, 1) WHEN level = 5 THEN rt.avg_speed * 31 * COALESCE(rt.carrils, 1) ELSE 0 END END ) AS intensity, COUNT(*) FILTER (WHERE rt.ntram IN (SELECT ntram FROM ntrams_in_bbox)) AS affected_ntrams, AVG(nbbox.total) AS total_ntrams FROM road_sections_with_types rt JOIN ntrams_in_bbox_count nbbox ON TRUE GROUP BY georss_date ), road_sections_with_i_class AS ( SELECT georss_date, CASE WHEN intensity >= 0 and intensity < 700 THEN 1 WHEN intensity >= 700 and intensity < 940 THEN 2 WHEN intensity >= 940 and intensity < 1250 THEN 3 WHEN intensity >= 1250 and intensity < 1550 THEN 4 ELSE 5 END AS level, affected_ntrams, total_ntrams FROM road_sections_with_intensities ), road_sections_with_i_class_adapted AS ( SELECT georss_date, ROUND(level::double precision * LEAST ((affected_ntrams::double precision / total_ntrams::double precision), 1)) AS level FROM road_sections_with_i_class ), filtered_data AS ( SELECT EXTRACT(ISODOW FROM georss_date) AS dow, EXTRACT(HOUR FROM georss_date) AS hour, CEIL(AVG(level))::integer AS level FROM road_sections_with_i_class_adapted GROUP BY EXTRACT(ISODOW FROM georss_date), EXTRACT(HOUR FROM georss_date) ) SELECT b.dow AS day, b.hour, COALESCE(fd.level, b.level) AS level FROM base_levels b LEFT JOIN filtered_data fd ON fd.dow = b.dow AND fd.hour = b.hour;`;
// tslint:enable



// WEBPACK FOOTER //
// ./src/app/historic/historic/constants.ts